<template>
  <div class="outline-stage">
    <div class="banner">
      <div class="banner-content">
        <div class="image"></div>
        <div class="content-text">
          <div class="row">加入创作交流群</div>
          <div class="row">福利抢先领，问题实时跟进</div>
        </div>
      </div>
    </div>
    <div class="guide-list">
      <div v-for="item, i in guideList" :key="i" @click.stop="selectItem(item.value, $event)" class="list-item guide-list-item">
        {{item.text}}
      </div>
    </div>
    <div class="divider">

    </div>
    <div class="support-list">
      <div v-for="item, i in supportList" :key="i" class="list-item support-list-item">
        {{item.text}}
      </div>
    </div>
    <div class="qrCode">
      <div class="word">扫码立即线上沟通</div>
      <div class="content">
        <img class="content-img" :src="QRImage" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      guideList: [
        {text: '新手入门', value: 'course'},
        {text: '使用教程', value: 'tutorial'},
        {text: '版本更新', value: 'version'},
        {text: '快捷键', value: 'hotkeys'},
      ],
      supportList: [
        {text: '线上咨询', value: 'supportStaff'},
        // {text: '意见反馈', value: 'feedback'}
      ],
      QRImage: ''
    }
  },
  computed: {
    ...mapGetters([
      'UserMsg',
      "UserLevel",
      'UserLevelInfo'
    ]),
    ...mapGetters({
      openSubtitle: "subtitle/openSubtitle"
    })
  },
  created() {
    const levelCode = this.UserLevelInfo.levelCode || 0;
    const trial = this.UserLevelInfo.trial;
    const isEnterprise = levelCode >= 2 && !trial;
    this.getQRData(isEnterprise ? '1689469857361592321' : '1689197785469190144');
  },
  methods: {
    selectItem (type, event) {
      switch (type) {
        case 'course':
          this.$bus.emit("getApiCourse");
          this.$store.commit("save_TopnavMsg", {
            isShowAnimCourseDialog: true,
          });
        break;
        case 'tutorial':
          this.$store.commit('helpCenter/setShownStage', 'tutorialTitle');
        break;
        case 'version':
          this.$bus.emit('openVersionPopup');
        break;
        case 'hotkeys':
          {
            const popupEvent = this.openSubtitle ? 'subtitlePopup' : 'FeaturesPop_vue';
            this.$bus.emit(popupEvent, {
              name: "shortcuts",
              initialX: event.pageX - event.offsetX,
              initialY: event.pageY - event.offsetY + 100,
              type: 1,
            });
          }
        break;
        case 'supportStaff':

          this.$store.dispatch('showServiceChat');
        break;
        case 'feedback':

        break;
      }

      if (type !== 'tutorial') {
        this.$store.commit('helpCenter/setPopoverShown', false);
      }
    },
    getQRData (id) {
      return new Promise(resolve => {
        wlQrcodeCustomComp.getQrCodeUrl(
          { wl_qrcode_id: id,},
          (data) => {
            console.log(`Turbo ~ getQRData ~ data`, data)
            localStorage.setItem('qrCode1',data.data.qr_code)
            this.QRImage = data.data.qr_code
            resolve(data);
          },
        );
      })
    }
  }

}
</script>

<style scoped lang="scss">
.banner {
  height: 133px;
  background: url(../../../assets/helpCenter/banner-bg.png) center center / 100% 100% no-repeat;
  margin-bottom: 6px;
  padding-top: 55px;
  font-weight: 400;
  .banner-content {
    display: flex;
    justify-content: space-between;
    padding-left: 17px;
    padding-right: 14px;
    text-align: left;
    .image {
      width: 62px;
      height: 62px;
      background: #FFFFFF;
      border: 1px solid #FFFFFF;
      opacity: 1;
      background: url('../../../assets/enterpriseWechat.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .content-text {
      .row:first-child {
        font-size: 14px;
        font-weight: bold;
        padding-top: 10px;
        padding-bottom: 6px;
      }
      .row {
        font-size: 12px;
      }
    }
  }
}
.list-item {
  display: flex;
  align-items: center;
  height: 36px;
  background: #FFFFFF;
  font-size: 14px;
  text-align: left;
  padding-left: 14px;
  padding-right: 14px;
  &:hover {
    background: #F8F8FC;
    cursor: pointer;
  }
}
.divider {
  width: 216px;
  height: 1px;
  background: #F2F3F7;
  opacity: 1;
  border-radius: 8px;
  margin-left: 14px;
  margin-top: 4px;
  margin-bottom: 4px;
}
.outline-stage {
  position: relative;

}
.support-list:hover + .qrCode{
  display: flex;
}

.qrCode {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 126px;
  width: 112px;
  position: absolute;
  top: 160px;
  left: 185px;
  border-radius: 8px;
  background: white;
  box-shadow: 4px 8px 7px 2px #afafaf;
  display: none;
  &:hover {
    display: flex;
  }
  .word {
    font-size: 10px;
    font-weight: bold;
    color: #3d3d3d;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 87px;
    height: 87px;
    background: url('../../../../static/img/codeBack.13ab4ed.png');
    background-size: contain;
    margin-top: 5px;
  }

  .content-img {
    height: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/helpCenter/outlineStage.vue